<template>
  <div
    class="mesage-wrap"
    :class="isManage ? 'isEdit' : ''"
    @touchmove="touchMove"
    @touchend="touchEnd"
    @click="cancelCtrl"
    v-loading.fullscreen="isLoading"
    :element-loading-text="$t(loadingAction)"
    element-loading-background="rgba(255, 255, 255, 0.6)"
  >
    <ul ref="messageList">
      <li
        @touchstart="touchStart($event, message.id)"
        v-for="message in messageList"
        :key="message.id"
        :class="
          (controlId == message.id ? 'isCtrl' : '') +
            ' ' +
            (viewDetailId == message.id ? 'select' : '')
        "
        :ref="'message' + message.id"
      >
        <div class="message-body">
          <i
            class="icon-select"
            :class="selectMsg.indexOf(message.id) >= 0 ? 'selected' : ''"
            @click.prevent.stop="selectOne(message.id)"
          ></i>
          <div
            class="message-cnt"
            :class="message.hasRead == 0 ? 'isNew' : ''"
            @click.stop="viewDetail(message.id)"
          >
            <h3>
              {{ message.title }}
            </h3>
            <p class="time">
              {{ message.updateTime || message.createTime | formatTime }}
            </p>
            <p>{{ message.brief }}</p>
          </div>
          <div class="message-ctrl">
            <a
              href="#"
              @click.prevent.stop="messageRead([message.id])"
              v-if="message.hasRead == 0"
              >{{ $t('已读') }}</a
            >
            <a href="#" @click.prevent.stop="messageDeleteOne([message.id])">{{
              $t('删除')
            }}</a>
          </div>
        </div>
      </li>
    </ul>
    <div class="no-data" v-if="messageList.length <= 0 && loaded">
      <img src="../../assets/img-m/no-list.png" />
      <p>{{ $t('暂无消息') }}</p>
    </div>
    <div class="eidt-bar">
      <label @click="selectAll"
        ><i
          class="icon-select"
          :class="
            selectMsg.length <= 0
              ? ''
              : selectMsg.length < messageList.length
              ? 'selectSome'
              : 'selected'
          "
        ></i
        ><span>{{ $t('全选') }}</span></label
      >
      <div>
        <a href="#" @click.prevent.stop="messageReadSelect">{{ $t('已读') }}</a>
        <a href="#" @click.prevent.stop="messageDeleteSelect">{{
          $t('删除')
        }}</a>
      </div>
    </div>
    <!-- <div class="detail-box" v-if="isViewDetail" @click.stop="hideDetail">
      <div class="detail-cnt" v-html="messageDetail[viewDetailId]"></div>
    </div> -->
  </div>
</template>
<script>
import getTranslation from '@/locale/getTranslation'
import { Dialog } from 'vant'
import { getMessageList, messageDelete, messageRead } from '@/api/exhibition'

export default {
  data() {
    return {
      isSelectAll: false,
      isManage: false,
      isLoading: false,
      loading: null,
      loadingAction: '',
      loaded: false,
      selectMsg: [],
      controlId: 0,
      controlId_t: 0,
      pageSize: 10,
      pageIndex: 1,
      isEnded: false,
      messageList: [],
      isViewDetail: false,
      viewDetailId: '',
      messageDetail: {},
      touchSX: 0,
      touchEX: 0,
      touchSY: 0,
      touchEY: 0
    }
  },
  created() {},
  mounted() {
    this.getMessageListAction()
    window.Message = {
      toEdit: () => {
        this.controlId = 0
        this.isManage = true
      },
      cancelEdit: () => {
        this.controlId = 0
        this.isManage = false
      }
    }
  },
  filters: {
    formatTime(_time) {
      let _msgTime = new Date(_time),
        _currTime = new Date()
      let _year = _msgTime.getFullYear(),
        _month =
          _msgTime.getMonth() + 1 < 10
            ? '0' + (_msgTime.getMonth() + 1)
            : _msgTime.getMonth() + 1,
        _date =
          _msgTime.getDate() < 10
            ? '0' + _msgTime.getDate()
            : _msgTime.getDate(),
        _hour =
          _msgTime.getHours() < 10
            ? '0' + _msgTime.getHours()
            : _msgTime.getHours(),
        _minute =
          _msgTime.getMinutes() < 10
            ? '0' + _msgTime.getMinutes()
            : _msgTime.getMinutes(),
        _second =
          _msgTime.getSeconds() < 10
            ? '0' + _msgTime.getSeconds()
            : _msgTime.getSeconds()

      if (
        _year == _currTime.getFullYear() &&
        _month == _currTime.getMonth() + 1 &&
        _date == _currTime.getDate()
      ) {
        return `${getTranslation('今天')} ${_hour}:${_minute}:${_second}`
      } else {
        return `${_year}.${_month}.${_date} ${_hour}:${_minute}:${_second}`
      }
    }
  },
  methods: {
    errorHandle(_err) {
      if (_err.status == 401 || _err.status == 429) return
      this.$message({
        type: 'error',
        message: _err.message || getTranslation('请求失败，请稍后重试~')
      })
    },
    async getMessageListAction() {
      if (this.isLoading) return
      this.isLoading = true
      try {
        let _data = await getMessageList({
          pageNum: this.pageIndex,
          pageSize: this.pageSize
        })
        this.isLoading = false
        this.loaded = true
        if (!_data.error) {
          if (this.pageIndex == 1) {
            this.messageList = _data.result.infos
          } else {
            this.messageList = [...this.messageList, ..._data.result.infos]
          }
          this.pageIndex += 1
          if (this.pageIndex > _data.result.pages) this.isEnded = true
        }
      } catch (_err) {
        this.isLoading = false
        this.errorHandle(_err)
      }
    },
    async viewDetail(_id) {
      if (this.controlId) {
        this.controlId = this.controlId == _id ? '' : _id
        return
      }
      let _messageList = this.messageList
      _messageList.forEach(message => {
        if (message.id == _id) {
          message.hasRead = 1
        }
      })
      this.messageList = [..._messageList]
      this.$router.push({ path: '/message/detail', query: { id: _id } })
      // if (this.messageDetail[_id]) {
      //   this.viewDetailId = _id
      //   this.isViewDetail = true
      //   return
      // }
      // try {
      //   let _data = await getMessageDetail({
      //     id: _id
      //   })
      //   if (!_data.error) {
      //     let _messageDetail = { ...this.messageDetail }
      //     _messageDetail[_id] = _data.result.content
      //     this.messageDetail = { ..._messageDetail }
      //     this.viewDetailId = _id
      //     this.isViewDetail = true
      //     this.messageRead([_id])
      //   }
      // } catch (_err) {
      //   this.errorHandle(_err)
      // }
    },
    hideDetail() {
      this.viewDetailId = ''
      this.isViewDetail = false
    },
    async messageDelete(_idArr) {
      try {
        let _data = await messageDelete({
          ids: _idArr
        })
        if (!_data.error) {
          this.selectMsg = []
          _idArr.forEach(_id => {
            this.$refs['message' + _id][0].style.height =
              this.$refs['message' + _id][0].offsetHeight + 'px'
            setTimeout(() => {
              this.$refs['message' + _id][0].style.height = '0'
            }, 50)
          })
          setTimeout(() => {
            let _messageList = [...this.messageList]
            _messageList.forEach((_message, index) => {
              if (_idArr.indexOf(_message.id) >= 0) {
                _messageList.splice(index, 1)
              }
            })
            this.messageList = [..._messageList]
          }, 3000)
        }
      } catch (_err) {
        this.errorHandle(_err)
      }
    },
    async messageRead(_idArr) {
      try {
        let _data = await messageRead({
          ids: _idArr
        })
        if (!_data.error) {
          let _messageList = [...this.messageList]
          _messageList.forEach(_message => {
            if (_idArr.indexOf(_message.id) >= 0) {
              _message.hasRead = 1
            }
          })
          this.messageList = [..._messageList]
          this.controlId = 0
        }
      } catch (_err) {
        this.errorHandle(_err)
      }
    },
    cancelCtrl() {
      this.controlId = 0
    },
    touchStart(_event, _id) {
      if (this.isManage) return
      if (_id) this.controlId_t = _id
      this.touchSX = this.touchEX = _event.touches[0].clientX
      this.touchSY = this.touchEY = _event.touches[0].clientY
    },
    touchMove(_event) {
      if (this.isManage) return
      this.touchEX = _event.touches[0].clientX
      this.touchEY = _event.touches[0].clientY
    },
    touchEnd() {
      if (this.isManage) return
      let _scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      let _c = 0
      if (this.touchEX < this.touchSX - 100) {
        _c = 1
      }
      if (_c == 1) {
        console.log('控制')
        this.controlId = this.controlId_t
      }
      if (this.touchEY - 300 > this.touchSY) {
        if (_scrollTop <= 0) {
          console.log('刷新')
          this.loadingAction = getTranslation('刷新中')
          this.pageIndex = 1
          this.isEnded = false
          this.getMessageListAction()
        }
      }
      if (this.touchEY < this.touchSY - 300) {
        if (
          this.$refs.messageList.offsetHeight - _scrollTop <=
          document.documentElement.clientHeight
        ) {
          console.log('加载下一页')
          this.loadingAction = getTranslation('加载下一页')
          if (this.isEnded) return
          this.getMessageListAction()
        }
      }
    },
    selectAll() {
      if (this.selectMsg.length < this.messageList.length) {
        this.selectMsg = []
        this.messageList.forEach(message => {
          this.selectMsg.push(message.id)
        })
      } else {
        this.selectMsg = []
      }
    },
    selectOne(_id) {
      if (this.selectMsg.indexOf(_id) >= 0) {
        this.selectMsg.splice(this.selectMsg.indexOf(_id), 1)
      } else {
        this.selectMsg.push(_id)
      }
    },
    messageReadSelect() {
      this.messageRead(this.selectMsg)
    },
    messageDeleteOne(_idArr) {
      Dialog.confirm({
        title: getTranslation('删除确认'),
        message: getTranslation('确定要删除此条消息？')
      }).then(() => {
        this.messageDelete(_idArr)
      })
    },
    messageDeleteSelect() {
      Dialog.confirm({
        title: getTranslation('删除确认'),
        message: getTranslation('确定要删除选中的消息？')
      }).then(() => {
        this.messageDelete(this.selectMsg)
      })
    }
  }
}
</script>
<style lang="scss">
.mesage-wrap {
  width: 100%;
  max-width: 800px;
  min-height: 100vh;
  margin: 0 auto;

  .icon-select {
    position: relative;
    display: inline-block;
    width: 0.36rem;
    height: 0.36rem;
    border: 1px solid #e6e9ee;
    border-radius: 0.18rem;
    background: #fff;
    transition: all 0.2s;

    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      left: 0.06rem;
      top: 0.08rem;
      width: 0.2rem;
      height: 0.1rem;
      border: 1px solid #fff;
      border-width: 0 0 1px 1px;
      transform: rotate(0) scale(0);
      transition: all 0.2s 0.2s;
    }

    &.selectSome {
      border: 1px solid #fe8c01;
      background: #fe8c01;
      &::before {
        width: 0.16rem;
        height: 0;
        left: 0.07rem;
        top: 0.14rem;
        transform: rotate(0) scale(1);
      }
    }

    &.selected {
      border: 1px solid #fe8c01;
      background: #fe8c01;
      &::before {
        transform: rotate(-45deg) scale(1);
      }
    }
  }

  ul {
    background: #fff;

    li {
      position: relative;
      overflow: hidden;
      transition: all 0.2s;

      .message-body {
        position: relative;
        padding: 0.28rem 0.2rem 0.28rem 0.64rem;
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
        overflow: hidden;
      }

      .icon-select {
        position: absolute;
        left: -0.36rem;
        top: 50%;
        transform: translateY(-50%);
      }
      .message-cnt {
        transition: all 0.2s;

        h3 {
          position: relative;
          margin: 0 0 0.2rem;
          color: #333;
          font-size: 0.32rem;
          line-height: 0.4rem;

          &::before {
            content: '';
            position: absolute;
            left: -0.36rem;
            top: 50%;
            width: 0.16rem;
            height: 0.16rem;
            border-radius: 0.08rem;
            background: #fe8c01;
            transform: translateY(-50%);
            opacity: 0;
            transition: all 0.2s;
          }

          span {
            float: right;
            color: #999;
            font-size: 0.24rem;
          }
        }
        p {
          color: #999;
          font-size: 0.28rem;
          line-height: 0.36rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;

          &.time {
            margin: -0.1rem 0 0.2rem;
            color: #999;
            font-size: 0.24rem;
            line-height: 0.28rem;
          }

          * {
            max-width: 100%;
          }
        }

        &.isNew {
          h3 {
            &::before {
              opacity: 1;
            }
          }
        }
      }
      .message-ctrl {
        position: absolute;
        right: -4rem;
        top: 0;
        bottom: 0;
        transition: all 0.2s;

        a {
          display: inline-block;
          width: 2rem;
          height: 100%;
          background: #ffb416;
          color: #fff;
          font-size: 0.28rem;
          text-align: center;

          &::before {
            content: '';
            display: inline-block;
            width: 0;
            height: 100%;
            vertical-align: middle;
          }
          &:first-child {
            float: left;
          }
          &:last-child {
            background: #f96137;
          }
        }
      }

      &.isCtrl {
        .message-cnt {
          transform: translateX(-4rem);
        }
        .message-ctrl {
          right: 0;
        }
        // transform: translateX(-4rem);
      }
      &.select::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 0.16rem;
        background: #fe8c01;
      }
    }
  }

  .eidt-bar {
    position: fixed;
    left: 0;
    bottom: -0.96rem;
    right: 0;
    height: 0.96rem;
    padding: 0 0.32rem;
    border-top: 1px solid #eee;
    background: #fff;
    transition: all 0.2s;

    label {
      display: inline-block;
      height: 0.6rem;
      margin: 0.18rem 0 0;
      padding: 0.12rem 0;

      .icon-select {
        margin: 0 0.2rem 0 0;
        vertical-align: top;
      }
      span {
        display: inline-block;
        color: #666;
        font-size: 0.24rem;
        line-height: 0.36rem;
        vertical-align: top;
      }
    }
    div {
      float: right;
      margin: 0.22rem 0 0;

      a {
        display: inline-block;
        width: 1.4rem;
        height: 0.52rem;
        margin: 0 0 0 0.2rem;
        border: 1px solid #fe8c01;
        border-radius: 0.26rem;
        color: #fe8c01;
        font-size: 0.24rem;
        text-align: center;
        line-height: 0.49rem;

        &:last-child {
          border-color: #ff4b4b;
          color: #ff4b4b;
        }
      }
    }
  }

  .detail-box {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 50% 0 0;
    background: rgba(0, 0, 0, 0.4);

    .detail-cnt {
      position: absolute;
      left: 0.3rem;
      right: 0.3rem;
      top: 50%;
      min-height: 40%;
      max-height: 94%;
      padding: 0.3rem;
      background: #fff;
      font-size: 0.24rem;
      line-height: 0.4rem;
      transform: translateY(-50%);
      overflow-x: hidden;
      overflow-y: auto;

      * {
        max-width: 100%;
      }
    }
  }

  .no-data {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #fff;
    padding: 40% 0 0;
    text-align: center;

    img {
      width: 3.6rem;
      height: auto;
      margin: 0 0 0.8rem;
    }
    p {
      color: #999;
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
  }

  &.isEdit {
    padding: 0 0 0.96rem;

    .message-body {
      padding-left: 0.96rem;

      .icon-select {
        left: 0.32rem;
      }
    }
    .eidt-bar {
      bottom: 0;
    }
  }
}
</style>
